import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';


import { pink, purple } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
// import Grid from '@mui/material/Grid';
// import moment from 'moment';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// import greenicon from 'leaflet/dist/images/leaf-green.png';
// import greenshadow from 'leaflet/dist/images/leaf-shadow.png';

// import redicon from 'leaflet/dist/images/leaf-green.png';
// import redshadow from 'leaflet/dist/images/leaf-shadow.png';

// import PageBase from '../site/PageBase';
//import LiveMap from './LiveMap';
import {apipost, apiraw, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg';
import submit from '../icons/submit.svg';
import process from '../icons/thinking.svg';
import complete from '../icons/task-complete.svg';

// import {blueIcon,goldIcon,redIcon,greenIcon,orangeIcon} from '../icons';
// import {yellowIcon,violetIcon,greyIcon,blackIcon} from '../icons';
import BadgeMarker, { AnimatedBadgeMarker } from '../maps';
import { Box } from '@mui/material';


const s:any = {
  maproot: {
    flexGrow: 1,
    flexShrink: 1,
  },
  // mapboardpaper: {
  //   backgroundColor: 'white',
  //   //maxHeight: 600,
  //   height: '100%',
  //   // height: 150
  //   marginLeft: 10,
  //   marginRight: 10,
  // },
  mapdiv: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  mapheader: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 1,
  },
  paper: {
    backgroundColor: 'white',
    minHeight: 1200,
    minWidth: 1000,
    overFlow: 'scroll',
    height: '100%',
    marginTop: 1,
  },
  div: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    minHeight: 1000,
    //height: 300,
    //mr: 15,
    //ml: 15,
  },
  header: {
    color: 'white',
    backgroundColor: pink['600'],
    padding: 1,
    fontSize: 24,
    fontWeight: 300,
  },
  custom_tooltip:{
    lineHeight: 0.2,
    backgroundColor: 'white',
    padding: 5
  },
  nodata: {
    display: 'flex',
    justifyContent: 'center'
  },
  barchart:{
    marginTop: 20
  }
};

const xsicons:any = {
  UNKNOWN:L.icon({iconUrl:apply,shadowUrl:iconShadow}),
  INITIATED:L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  COMPLETED:L.icon({iconUrl:submit,shadowUrl:iconShadow}),
  FAILED:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  CANCELLED:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  TIMEOUT:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
  DUPLICATE:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
}

//const ntrmsicon = L.icon({iconUrl:process,shadowUrl:iconShadow});

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;



/*

var myIcon= L.Icon.extend({
        options: {
            iconUrl: 'icon.png',
            iconSize: [7.5, 7.5],
            iconAnchor: [0, 0]
        }
    });

var ic = new myIcon({iconSize: [7.5, 7.5]});
    var marker = L.marker([-15.7745457, -48.3575684], {icon: ic}).addTo(map);

map.on('zoomend', function() {
var actualZoom = map.getZoom();
var newSize = 60/((20 - actualZoom )*2);

var resizedIcon = new myIcon({iconSize: [newSize ,newSize ]});      
marker.setIcon(resizedIcon );
});

*/

class EventMap extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map:any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    const {mapper={}} = this.props;
    const {cc=[5.64046614, -0.2921927]} = mapper;
    const {bb=[[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]]} = mapper;
    const mcenter:LatLngExpression = cc; //||[8.977850, 39.253099];
    const mpos:LatLngExpression = cc; //||[9.01055, 38.74750];
    const mtext = `NTRMS Event. <br /> Event Location.`;
    const mbounds:LatLngBoundsExpression = bb;
    const mzoom = 13;
    const mtitle = 'Event Map';
    
    const {title=mtitle,mapcenter=mcenter,mapbounds=mbounds,mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mpos,markertext=mtext} = props;

    this.state = {
      count: 0,
      mtitle:title,
      mcenter:mapcenter,
      mbounds:mapbounds,
      mzoom:mapzoom,
      mpos:mappos,
      mtext:maptext,
      mkpos:markerpos,
      mktet:markertext,
      regmap: null,
      dismap: null,
    };
  }

  componentDidMount(): void {
      const cmap = this.map.current;
      //console.log('map',cmap);
      this.baseload();
  }

  //import L from "leaflet";

  /**
   * Computes a LatLngBounds representing a W×H pixel rectangle
   * centered on a given lat/lng at a specific zoom level.
   */
  getBoundsFromCenterPx(
    map: L.Map,
    center: L.LatLngExpression,
    widthPx: number,
    heightPx: number,
    zoom: number
  ): L.LatLngBounds {
    const centerLatLng = L.latLng(center);

    // Center in pixel space
    const centerPoint = map.project(centerLatLng, zoom);

    const halfW = widthPx / 2;
    const halfH = heightPx / 2;

    // Pixel-space corners
    const southWestPoint = L.point(
      centerPoint.x - halfW,
      centerPoint.y + halfH
    );

    const northEastPoint = L.point(
      centerPoint.x + halfW,
      centerPoint.y - halfH
    );

    // Convert back to lat/lng
    const southWest = map.unproject(southWestPoint, zoom);
    const northEast = map.unproject(northEastPoint, zoom);

    return L.latLngBounds(southWest, northEast);
  }

  getBoundsFromCenterPxCRS(
    center: L.LatLngExpression,
    widthPx: number,
    heightPx: number,
    zoom: number
  ): L.LatLngBounds {
    const c = L.latLng(center);
    const crs = L.CRS.EPSG3857;

    const p = crs.latLngToPoint(c, zoom);

    const sw = crs.pointToLatLng(
      L.point(p.x - widthPx / 2, p.y + heightPx / 2),
      zoom
    );

    const ne = crs.pointToLatLng(
      L.point(p.x + widthPx / 2, p.y - heightPx / 2),
      zoom
    );

    return L.latLngBounds(sw, ne);
  }

  mapload = async(file:string) => {
    try{
      const baseparams = {file};
      const response = await apiraw('/api/resource/maps','',baseparams);
      return response; //TODO: return file
    }
    catch(error){
      console.log('mapload error',error);
      return Promise.reject(error);
    } 
  //TODO: call LoadMarkers
  
  }

  baseload = async() => {
    try{
      const rs = await this.mapload('ghana_regions.json');
      //console.log('regmap.rs',rs);
      this.setState({regmap:rs});

      const ds = await this.mapload('ghana_towns.json');
      //console.log('dismap.ds',ds);
      this.setState({dismap:ds});
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);

  dedupe = (field:string,data:any[]) => Object.values(
    data.reduce((acc, rec) => {
        const key = rec[field]; // Field to check for duplicates

        if (!acc[key]) {
            // If the key is not in the accumulator, initialize it with the item and set count to 1
            acc[key] = { ...rec, count: 1 };
        } else {
            // If the key exists, increment the count of the retained record
            acc[key].count++;
        }
        return acc;
    }, {}) // Start with an empty object {}
  );

  remerge = (f:string, p:string, ...arrs:any[]) => this.dedupe(f,this.merge(p,...arrs));

  render() {
    const {classes} = this.props;
    const {mtitle,mcenter,mbounds,mzoom,mpos,mtext,mkpos,mktext} = this.state;
    const {regmap,dismap} = this.state;
    const {title=mtitle,recordset=[],mapcenter=mcenter,mapbounds=mbounds} = this.props;

    const {mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mkpos} = this.props;

    const {markertext=mktext} = this.props;

    // console.log('regmap',regmap);
    // console.log('dismap',dismap);
    // console.log('recordset',recordset);
    const rcset = (recordset === null)?[]:recordset;
    const records = this.dedupe('lci',rcset);

    // For full Ghana map, use the following
    //const bounds:LatLngBoundsExpression = [[4.873673,-3.397779],[11.180002,1.381273]];
    //const center:LatLngExpression = [8.34046614, -0.4921927];
    //const pos:LatLngExpression = [5.95446614, -0.2921927];
    //const zoom = 7;

    // For zoomed into Accra metropolis, use the following
    // const pos:LatLngExpression = [5.95446614, -0.2921927];
    // const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    // const center:LatLngExpression = [5.64046614, -0.2921927];
    // const zoom = 13;

    // For zoomed into Accra metropolis, use the following
    const npos:LatLngExpression = [5.54959014, -0.1964927]; //default
    const gpos:LatLngExpression = [5.57059614, -0.1924027]; //green
    const fpos:LatLngExpression = [5.62590614, -0.1801927]; //gold
    const bpos:LatLngExpression = [5.66296614, -0.1534027]; //red
    //const bounds:LatLngBoundsExpression = [[5.01046214438, -3.24437008301],[11.3983409693, 1.0601216976]];
    const bounds:LatLngBoundsExpression = [[4.51046214438, -3.75437008301],[11.4983409693, 1.2701216976]];
    const center:LatLngExpression = [8.00946644, -1.2221927];
    const zoom = 8;

    //
    //const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    //const boundx:LatLngBoundsExpression = [[-3.318,11.265],[1.406,4.489]];
    //const bounds:LatLngBoundsExpression = [[4.489,-3.318],[11.265,1.406]];
    //const bounds:LatLngBoundsExpression = [[4.873673,-3.397779],[11.180002,1.381273]];
    //const center:LatLngExpression = [8.34046614, -0.4921927];
    //const center = bounds.getCenter();

    return (
      <Paper sx={{...s.paper}}>
        <Box sx={{...s.header}}>{title}</Box>
        <Box sx={{...s.div}}>
          <ResponsiveContainer >
            <MapContainer 
              ref={this.map} 
              center={center} 
              zoom={zoom} 
              scrollWheelZoom={false} 
              style={{height:'100vh',width:'100%',minHeight:1200}} 
              bounds={bounds}>
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={bounds}
              />
              {regmap && <GeoJSON attribution="&copy; credits due..." data={regmap} style={{color:'#6699EE'}} />}
              {dismap && <GeoJSON attribution="&copy; credits due..." data={dismap} style={{color:'#999999'}} />}
              {/* <BadgeMarker
                position={[5.6037, -0.1870]}
                badgeValue={12}
                badgeColor="purple"
                onClick={() => alert("Marker clicked!")}
              /> */}
              {/* <BadgeMarker
                position={[5.6, -0.18]}
                value="99+"
                sx={{ fontWeight: "bold", backgroundColor: "#673ab7" }}
                animate={true}
              /> */}
              {/* <AnimatedBadgeMarker
                position={[5.6, -0.18]}
                value={7}
                badgeColor="#651fff"
                textColor="#fff"
                sx={{ fontWeight: "bold" }}
              /> */}
              {/* <Marker position={npos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker> */}
              {/* <Marker position={bpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker> */}
              {/* <Marker position={fpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker> */}
              {/* <Marker position={gpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker> */}
              {/* {(recordset.length > 0) && recordset.map((record:any, idx:number) => 
              // <Marker key={record.rid} position={record.geo} icon={xsicons[record.evc]}>
              <Marker key={record.rid} position={record.geo} icon={DefaultIcon}>
                <Popup>
                  <Box component='span'>TRACK:{record.tri}<br/>REF:{record.rfn}<br/>MMC:{record.clc}<br/>RCB: {record.brc}<br/>TYPE: {record.xtc}<br/>STATUS: {record.xsc}<br/>DATE: {record.dcd}</Box>
                </Popup>
              </Marker>
              )} */}
               {(records.length > 0) && records.map((record:any, idx:number) => 
               <AnimatedBadgeMarker  key={record.rid} 
                position={record.geo}
                value={record.count||0}
                badgeColor="rgba(255, 31, 221, 1)"
                textColor="#fff"
                sx={{ fontWeight: "bold" }}
              >
                <Popup>
                  <Box component='span'>
                    <u><b>BUDGET TRANSACTION</b></u><br/>
                    <b>TRACK.ID:</b> {record.tri}<br/>
                    <b>REF.NO:</b> {record.rfn}<br/>
                    <b>MMC:</b> {record.clc}<br/>
                    <b>RCB:</b> {record.bkn}<br/>
                    <b>BRANCH:</b> {record.brn}<br/>
                    <b>TYPE:</b> {record.xtc}<br/>
                    <b>STATUS:</b> {record.xsc}<br/>
                    <b>DATE:</b> {record.dcd}
                  </Box>
                </Popup>
              </AnimatedBadgeMarker>
              )}
            </MapContainer>
          </ResponsiveContainer>
        </Box>
      </Paper>
    );
  }
}

EventMap.propTypes = {
  data: PropTypes.array
};

export default EventMap;



/*
  /////////////////// OTHER METHODS  ////////////////////////


  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }


  //////////////////////////////map//////////////////////////////
  mapload = async(filename:string) => {
    try{
      const baseparams = {filename}; //,sta:date
      const response = await apipost('/api/resource/map','',baseparams);
      //this.setState({markers:response.sd});
      //this.map.addLayer(this.liveLayer);
      //this.liveLayer.clearLayers();
      //this.loadMakersLeaflet();
      return response; //TODO: return file
    }
    catch(error){
      console.log('map.bizpost error',error);
      return Promise.reject(error);
    } 
    //TODO: call LoadMarkers
    
  }

  baseload = async() => {
    try{
      return await this.mapload('ghana-regions.json');
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }



    liveLoad = async(code:any,date:any) => {
      try{
        const {recordset:previousset,lastread} = this.state;
        const {eni} = this.props;
        //const start = moment.format()
        const baseparams = {s:'marker',a:'find',eni,stp:lastread};
        const response = await bizpost(baseparams);
        const {sd:currentset} = response;
        const recordset = this.merge('rid',previousset,currentset);
        this.setState({recordset,previousset,currentset});
        //this.map.addLayer(this.liveLayer);
        //this.liveLayer.clearLayers();
  
        //this.loadMakersLeaflet();
      }
      catch(error){
        console.log('map.bizpost error',error);
      } 
      //TODO: call LoadMarkers
      
    }
  
    ttFormatTime = (stamp:any) => {
      return moment.unix(stamp).format('DD MMM');
    }
  
    /////////////////  ACCESSING THE MAP VANILLA JS/HTML////////////////////////
    var map = L.map('map').setView([55.4411764, 11.7928708], 13);

    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    // quick and dirty: create a big icon
    L.Icon.Big = L.Icon.Default.extend({
        options: {
        iconSize: new L.Point(45, 81),
    }});

    var bigIcon = new L.Icon.Big();
    var centerPoint = L.latLng(55.4411764, 11.7928708);
    var centerMarker = L.marker(centerPoint, { title: 'unselected' });
    centerMarker.addTo(map);

    centerMarker.on('click', function(e) {
        centerMarker.setIcon(bigIcon);
    });
    */